const DIMENSIONS = {
  topBarHeight: 80,
};


export default DIMENSIONS